import React, { useState } from "react";

import styled, { css } from "styled-components";

import "./css/normalize.css";
import "./css/webflow.css";
// import "./css/xsolla-com-cards.webflow.css";
import "./css/xcomadd2.css";

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  Button,
  StatusDot,
  ContentBlock,
  Tooltip,
  Card,
  Icon,
  Slider,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";

import { xsollaProducts } from "../../data/xsollaProducts";


import { cardsProduction, prepareData } from "../../data/cards-jan-10-2020";

import { Switch, Route, Link } from "react-router-dom";

import { PAsolutionCards } from "../cards/PAsolutionCards";
import PAslider from "../PAslider";
import { isStyledComponent } from "styled-components";
import { ProductIcon } from "../../data/ProductIcon";
import {
  ButtonOutlineWhite,
  CSSonlyMob,
  CSSonlyWeb,
  CSSbigInput
} from "../uikit2";
import {
  microtransactionsSolutions,
  currencySolutions,
  sitebuilderSolutions,
  launcherSolutions,
  loginSolutions,
  paystationSolutions,
  partnernetworkSolutions
} from "../../data/defaultSolutions";
import PAh2 from "../PAh2";
import { PAchartKA } from "../dashboard/PAchartUsersMethods";
import PAxcom, { PAxcomTop } from './PAxcom';
import { PAxcomCards } from './PAxcomCards';



const all = {
  cards: prepareData(),
  // cards: [
  //   ...microtransactionsSolutions,
  //   ...sitebuilderSolutions,
  //   // ...currencySolutions,
  //   ...paystationSolutions,
  //   ...launcherSolutions,
  //   ...loginSolutions,
  //   ...partnernetworkSolutions
  // ],
  product: "all",
  filters: [
    {
      label: "All stages",
      tooltip: "All solutions",
      value: "all"
    },
    {
      label: "Pre-launch",
      value: "before",
      tooltip: (
        <div>
          Show solutions for:
          <br />
          Pre-orders / crowdfunding (2)
          <br />
          Audience Gathering (3)
        </div>
      )
    },
    {
      label: "Early access",
      value: "launch",
      tooltip: (
        <div>
          Show solutions for:
          <br />
          Founder packs sales (2)
          <br />
          Audience Gathering (3)
          <br />
          Launch events (1)
        </div>
      )
    },
    {
      label: "Live game",
      value: "after",
      tooltip: (
        <div>
          Show solutions for:
          <br />
          Additional monetization (2)
          <br />
          Recurrent payments (3)
        </div>
      )
    }
  ]
};

const bluePages = {
  store: {
    cards: microtransactionsSolutions,
    product: "store",
    filters: []
  },
  currency: {
    cards: currencySolutions,
    product: "currency",
    filters: []
  },
  pay_station: {
    cards: paystationSolutions,
    product: "pay_station",
    filters: []
  },
  site_builder: {
    cards: sitebuilderSolutions,
    product: "site_builder",
    filters: []
  },
  launcher: {
    cards: launcherSolutions,
    product: "launcher",
    filters: []
  },
  login: {
    cards: loginSolutions,
    product: "login",
    filters: []
  },
  partner_network: {
    cards: partnernetworkSolutions,
    product: "partner_network",
    filters: []
  },

  all: {
    ...all
  }
};

export default function PAcards({
  manyProjects, //TODO:TEMP
  product = "microtransactions",
  title,
  backUrl,
  hardlimit,
  limit,
  hist
}) {
  return (
    <div className="">
      <PAxc
        {...bluePages[product]} //all
        title={title}
        hardlimit={hardlimit}
        limit={limit}
        key={`title_${title}`}
      />
    </div>
  );
}


const monetization = [
  {
    value: 'microtransactions',
    label: "Microtransactions"
  },
  {
    value: 'premium',
    label: "Premium"
  },
  {
    value: "marketing",
    label: "Subscriptions"
  },
  // {
  //   value: "funding",
  //   label: "Funding"
  // }
];

const platforms = [
  {
    value: "win",
    label: "PC/Mac"
  },
  {
    value: "mac",
    label: "Web"
  },
  {
    value: "mobile",
    label: "Mobile"
  },
  {
    value: "console",
    label: "Console"
  },
];



const platfDefault = [
  "win",
  "console",
  "mobile",
  "mac",
  'microtransactions',
  'premium',
  "subscriptions",
];

export function PAxc({
  hist,
  cards,
  hardlimit,
  filters = [],
  filter,
  title,
  limit
}) {

  const [filt, setFilter] = useState(
    filters.length ? filters[1]["value"] : null
  );

  const [platf, setPlatf] = useState([...platfDefault]);
  const [filtNum, setFilterNum] = useState(filters ? 1 : null);


  window["swiperHandle"] = ind => {
    if (typeof ind !== "undefined") setFilter(filters[ind]["value"]);
  };

  const filterCards = (filt, cards) => {
    if (cards.length && !cards[0]["tag"]) {
      return cards;
    }
    // debugger
    return cards.filter(
      (oneCard, ind) =>
        !filt || (oneCard["tag"] && oneCard["tag"].indexOf(filt) !== -1)
    );
  };

  const handlePlatform = v => {
    let p = [...platf];
    if (p.indexOf(v) === -1) {
      p = [...p, v];
    } else {
      p.splice(p.indexOf(v), 1);
    }
    setPlatf(p);
  };

  const checkIf = oneF => {
    let ret;
    filters.forEach(oneF => {
      ret = platf.indexOf(oneF) !== -1 ? true : false;
    });
    return ret;
  };

  return (
    <PAxcom>
      <PAxcomTop>

        <CardFilters
          key="filters1"
          filt={filt}
          filters={filters}
          setFilter={setFilter}
          setFilterNum={setFilterNum}
        />
        <CardFilters2
          key="filters2"
          needs={monetization}
          platf={platf}
          handlePlatform={handlePlatform}
        />
        <CardFilters3
          key="filters3"
          needs={monetization}
          platf={platf}
          handlePlatform={handlePlatform}
        />

      </PAxcomTop>


      <div className="l_block">


        <div className="l_content"
          // style={{position: 'relative', zIndex: 1}}
          >
          <div className="l_content_center">

          <div className="x_bg_xbe"></div>

            <div className="l_width_1160">
              <FormGroup indentation="lg">
                <PAxcomCards
                  limit={limit}
                  hardlimit={hardlimit}
                  platforms={platf}
                  // size="sm" //TODO: отключение картинки
                  // solutions={filterCards(filt, cards)}
                  solutions={cards}
                  filter={filt}
                  appear={true}
                />

                {/* </div> */}
              </FormGroup>
              <br/>
            </div>
          </div>
          <div className="l_block_bg" />
        </div>
        <div className="l_block_bg" />
      </div>
    </PAxcom>
  );
}


export const CardDecals = ({
  label = 'Stage'
}) => {
  return (
    <div className="t_label_w-3">
      <div className="x_cat_decal_h">
        {label}
      </div>
      <div className="x_cat_decal" />
    </div>
    )}


export const CardFilters = ({
  filt,
  filters = [],
  setFilter = () => void 0,
  setFilterNum = () => void 0
}) => {
  return (
    <div className="x_cat_line">

      <div className="l_line">

        <CardDecals label="Stage"/>

        <div className="x_cat_sel0">
          {filters.map((oneF, index, filters) => (

            <div
            key={`filters1_${index}`}
              className={`x_cat_item x_cat_item_or ${
                `${(index > 0 && index < 3) ? ' x_cat_item_next' : ''} ${filt !== oneF["value"] ? "" : " x_cat_item--active"}`
              }`}
            >
              <div
                className={`x_sol_cardsul ${filt !== oneF["value"] ? "" : " x_sol_cardsul--active"}`}
                onClick={() => {
                  setFilter(oneF["value"]);
                  setFilterNum(index);
                }}
              >


                <div className="x_cat_type_h">
                  {oneF["label"]}
                </div>


            </div>
            </div>

          ))}
        </div>
      </div>
    </div>
  );
};



export const CardFilters2 = ({
  needs = [],
  platf = [],
  handlePlatform = () => void 0
}) => {
  return (
    <div className="x_cat_line">

      <CardDecals label="Monetization"/>

      <div className="l_line">
        <div className="x_home_solutions-grid x_home_solutions-grid--4">
          {needs.map((oneF, index, filters) => (

            <div
              key={`filters2_${index}`}
              className={`x_cat_item ${
                platf.indexOf(oneF["value"]) === -1 ? "" : " x_cat_item--active"
              }`}
              onClick={() => handlePlatform(oneF["value"])}
            >
              <div
              className={`x_sol_cardsul ${
                platf.indexOf(oneF["value"]) === -1 ? "" : " x_sol_cardsul--active"
              }`}
              >
                <div className="x_cat_type_h">
                  {oneF["label"]}
                </div>
              </div>

              <div className="x_cat_item_active">
                <div className="x_cat_item_check w-embed">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                      stroke="#4F5C69"
                    />
                  </svg>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export const CardFilters3 = ({
  needs = [],
  platf = [],
  handlePlatform = () => void 0
}) => {
  return (
    <div className="x_cat_line">

      <CardDecals label="Platform"/>

      <div className="l_line">
        <div className="x_home_solutions-grid x_home_solutions-grid--4">
          {platforms.map(
            (oneF, index, filters) => (
              <div
                key={`filters3_${index}`}
                className={`x_cat_item ${
                  platf.indexOf(oneF["value"]) === -1
                    ? ""
                    : " x_cat_item--active"
                }`}
                onClick={() => handlePlatform(oneF["value"])}
              >

                <div
                  className={`x_sol_cardsul ${
                    platf.indexOf(oneF["value"]) === -1 ? "" : " x_sol_cardsul--active"
                  }`}
                >
                  <div className="x_cat_type_h">
                    {oneF["label"]}
                  </div>
                </div>


                <div className="x_cat_item_active">
                  <div className="x_cat_item_check w-embed">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                        stroke="#4F5C69"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            )

          )}
        </div>
      </div>
    </div>
  );
};
